/* FRONT PAGE SCRIPTS */

jQuery(document).ready(function($) {	
	initPreloaderScreen();
	initSliders();	
	initHellobar();	
	syncAccordionAndSwiper();
});

function initPreloaderScreen() {
	setTimeout(function(){
		jQuery('.home #loader').addClass('animated zoomOut');		
	}, 1000);
	setTimeout(function(){		
		jQuery('.home #loader-wrapper').fadeOut('slow');	
		jQuery('.home .off-canvas-wrapper').css('opacity', 1);
	}, 1550);
	initSubmenus();
}


// Global variable to store the active slide index
var activeSlideIndex = 0;

// Function to handle the accordion and Swiper slider synchronization
function syncAccordionAndSwiper() {
  var myVideoSwiper;

  // Function to update the active accordion item based on the active Swiper slide
  function updateActiveAccordionItem() {
	// Remove the "active" class from all accordion items
	jQuery(".faq-accordion .wp-block-kadence-pane").removeClass("active");
	jQuery("#faq-content #image-section .kt-inside-inner-col .swiper-video-slider-section").addClass("is-style-add-dots-accent");
	jQuery("#faq-content #image-section .kt-inside-inner-col .swiper-video-slider-section .swiper-container").removeClass("standard-video-slider");
	// Find the corresponding accordion item and add the "active" class
	var accordionItem = jQuery(".faq-accordion .wp-block-kadence-pane").eq(activeSlideIndex);
	accordionItem.addClass("active");
  }

  // Initialize Swiper after the page is fully loaded
  jQuery(document).ready(function() {
	myVideoSwiper = new Swiper("#faq-content #image-section .swiper-video-slider-section .swiper-container", {
	  direction: "horizontal",
	  loop: false,
	  autoHeight: false,
	  slidesPerView: 1,
	  spaceBetween: 10,
	  allowTouchMove: false,
	  centeredSlides: false,
	  effect: "fade",

	  breakpoints: {
		768: {
		  slidesPerView: 1,
		  spaceBetween: 20,
		},
		1024: {
		  slidesPerView: 1,
		  spaceBetween: 20,
		},
		1200: {
		  slidesPerView: 1,
		  spaceBetween: 20,
		},
	  },

	  on: {
		init: function() {
			
		  // On page load, add the "active" class to the first accordion item and the first swiper slide
		  jQuery(".faq-accordion .wp-block-kadence-pane").first().addClass("active");
		  updateActiveAccordionItem(); // Update active accordion item on Swiper init
		},
		slideChange: function() {
		  activeSlideIndex = myVideoSwiper.activeIndex;
		  updateActiveAccordionItem();
		},
	  },
	});

	// Attach click event to accordion container (using event delegation)
	jQuery(".faq-accordion").on("click", ".wp-block-kadence-pane", function() {
	  var clickedIndex = jQuery(this).index();
	  if (clickedIndex !== activeSlideIndex) {
		myVideoSwiper.slideTo(clickedIndex, 200, false);
	  }
	});
  });

  // Call the function to update the active accordion item initially (in case Swiper is already initialized)
  updateActiveAccordionItem();
}

// Call the synchronization function
syncAccordionAndSwiper();




function initSubmenus() {
	jQuery('.top-bar #menu-topnav-1').css('opacity',1);	
/*	setTimeout(function(){
		jQuery('.top-bar .fixedlogo').css('display','block').addClass('animated fadeInLeft');
	}, 800); */
}


function initSliders(){	
	/* https://swiperjs.com/get-started/  */

	var fpcarouselinner = jQuery('.fp-carousel-row-inner');
	if(fpcarouselinner.length) {  
	  var mySwiper = new Swiper ('.fp-carousel-row-inner' , {
	    // Optional parameters
	    direction: 'horizontal',
	    loop: true,
	    autoHeight: true,
	    slidesPerView: 1,
		spaceBetween: 10,
	
	    // If we need pagination
	    pagination: {
	      el: '.swiper-pagination',
	      clickable: true,
	      type: 'bullets',
	      	      
	    },
	
	    // Navigation arrows
	    navigation: {
	      nextEl: '.swiper-button-next',
	      prevEl: '.swiper-button-prev',
	    },
	
	    // And if we need scrollbar
	    scrollbar: {
	      el: '.swiper-scrollbar',
	      draggable: true,
	    },
	  })
	}
}	

function initHellobar(){
	var helloBarContainer = jQuery('#hello-bar-main');
	if(helloBarContainer.length){
		jQuery('#hello-bar-close-btn').click(function() {
		 helloBarContainer.animate({
			  maxHeight: '0',
			  opacity: '0',
			  padding: '0',
			});
		});	
	}
}

// VIDEO FOR FRONT PAGE
function initHpVideo() {		
			var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		
	jQuery('.banner-wrapper .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false; 
		
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".banner-wrapper .video").addClass("mobile");
			jQuery(".banner-wrapper .video").removeClass("desktop");
		} else {
			jQuery(".banner-wrapper .video").addClass("desktop");
		}
	});
}


//accredit / accreditations  slider 
// Wait for the DOM to be ready
jQuery(document).ready(function ($) {
  var mswiper; // Define mswiper outside of the functions to make it accessible.

  // Function to initialize Swiper
  function initSwiper() {
	mswiper = new Swiper('.accredit-slider.swiper-container', {
	  slidesPerView: 'auto', // Adjust as needed
	  spaceBetween: 0, // Adjust as needed
	  loop: true,
	  grabCursor: true,
	  navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	  },
	  autoplay: {
		  delay: 0,
		  disableOnInteraction: false, // Allow user interaction to stop autoplay
	  },
	  speed: 1000,
	  breakpoints: {
		// Define breakpoints if needed
	  },
	});
  }

  // Function to check screen size and execute code
  function checkScreenSize() {
	if (jQuery(window).width() < 769) {
	  // If the screen width is less than 768px, add the class and initialize Swiper if it hasn't been initialized yet
	  jQuery('#turn-to-slider-row .kt-inside-inner-col').addClass('accredit-slider swiper-container');
	  if (typeof mswiper === 'undefined') {
		initSwiper();
	  }
	} else {
	  // If the screen width is 768px or more, remove the class and destroy Swiper if it has been initialized
	  jQuery('#turn-to-slider-row .kt-inside-inner-col').removeClass('accredit-slider swiper-container');
	  if (typeof mswiper !== 'undefined' && mswiper !== null) {
		mswiper.destroy();
		mswiper = undefined; // Reset the swiper variable
	  }
	}
  }

  // Initial check when the page loads
  checkScreenSize();

  // Check screen size when the window is resized
  jQuery(window).resize(function() {
	checkScreenSize();
  });
});